import React from 'react';

import { Text } from '@rbilabs/universal-components';

import { SodiumFlag } from 'components/product-detail-v2/nutrition-information';
import { useLocale } from 'state/intl';
import { Region } from 'utils/environment/types';

export const SodiumDisclaimerUS = () => {
  const { region } = useLocale();
  if (region === Region.US) {
    return (
      <Text variant="copyTwo">
        Warning: <SodiumFlag size="22px" style={{ transform: [{ translateY: 5 }] }} /> indicates
        that sodium (salt) content of this item is higher than the total daily recommended limit
        (2,300mg). High Sodium intake can increase blood pressure and risk of heart disease and
        stroke.
      </Text>
    );
  }
  return null;
};
